import { Box, Tooltip } from '@mui/material';
import { useState } from 'react';
// import AiPresentationIcon from '../../../assets/webImages/Icon-Presentation.svg';
import { Presentation } from "lucide-react";
import AiPresentation from './AiPresentation';

const AiPresentationPopup = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Generate a presentation" arrow>
        <Box
          sx={{
            backgroundColor: '#0066cc',
            borderRadius: '50%',
            width: '4rem',
            height: '4rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            zIndex: '2',
          }}
          onClick={() => setOpen((state) => !state)}
        >
          {/* <img src={AiPresentationIcon} width="45px" height="45px" alt="ai presentation" /> */}
          <Presentation size={32} color="white" />
        </Box>
      </Tooltip>
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: '7rem', md: '5rem' },
          right: { xs: '0', md: '4rem' },
          width: {
            xs: '100%',
            md: '80%',
            lg: '60%',
            xl: '40%',
          },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transition: 'all 0.3s ease',
          opacity: open ? '1' : '0',
          visibility: open ? 'visible' : 'hidden',
        }}
      >
        <AiPresentation />
      </Box>
    </>
  );
};

export default AiPresentationPopup;
